import { render } from "./NavbarLinks.vue?vue&type=template&id=0f556733&scoped=true"
import script from "./NavbarLinks.vue?vue&type=script&lang=js"
export * from "./NavbarLinks.vue?vue&type=script&lang=js"

import "./NavbarLinks.vue?vue&type=style&index=0&id=0f556733&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aryav\\Desktop\\Don't touch this file\\Talreq\\talreq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f556733"]])

export default __exports__